import { IonLoading } from "@ionic/react";
import { ReactNode, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router";

import { ApiTokenContext } from "@/contexts/api-token/ApiContextWrapper";
import { UserContext } from "@/contexts/user/UserContext";
import { ROUTING } from "@/utils/constants/routing";
import {
  getPostAuthRoute,
  isAuthGuestRoute,
  needsOwnerProfileSetup,
} from "@/utils/routing/postAuthRoute";

function OwnerProfileGate({ children }: { children: ReactNode }) {
  const { token, isRenewingToken } = useContext(ApiTokenContext);
  const { user } = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  const isLoadingUser =
    Boolean(token) && user === null && !isRenewingToken;
  const needsOwnerProfile = user ? needsOwnerProfileSetup(user) : false;
  const isOnboardingRoute =
    location.pathname === ROUTING.ONBOARDING_ORGANIZATION;
  const onAuthGuestRoute = isAuthGuestRoute(location.pathname);
  const shouldRedirectFromAuthGuestRoute = Boolean(token) && onAuthGuestRoute;

  useEffect(() => {
    if (isLoadingUser) {
      return;
    }

    if (shouldRedirectFromAuthGuestRoute && user) {
      history.replace(getPostAuthRoute(user));
      return;
    }

    if (!user || !needsOwnerProfile || isOnboardingRoute) {
      return;
    }

    history.replace(ROUTING.ONBOARDING_ORGANIZATION);
  }, [
    history,
    isLoadingUser,
    isOnboardingRoute,
    needsOwnerProfile,
    shouldRedirectFromAuthGuestRoute,
    user,
  ]);

  if (isLoadingUser || shouldRedirectFromAuthGuestRoute) {
    return <IonLoading isOpen message="Loading..." />;
  }

  if (needsOwnerProfile && !isOnboardingRoute) {
    return null;
  }

  return children;
}

export { OwnerProfileGate };